import type { Hotel } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { ReOnboardingRequestInputZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

type QueryData = Pick<Hotel, "hotelID" | "email">;

export type ReOnboardingRequestFormModel = AutoGeneratorForFormModel<
	ReOnboardingRequestInputZodSchemaType,
	ExcludeKeys,
	QueryData
>;
